// @ts-nocheck
import { createTheme } from '@mui/material/styles';
import { primary, secondary, error, success, warning, info } from '../Colors';

// Updated button styles with theme customizations
const buttonTheme = createTheme({
  palette: {
    mode: 'light',
    primary,
    secondary,
    error,
    success,
    warning,
    info,
  },

  components: {
    // button styles
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        disabledRipple: true,
      },
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          fontFamily: 'Roboto',
          fontWeight: 500,
          padding: '5px 16px',
          textTransform: 'none',
        },

        containedPrimary: {
          color: primary.textColor,
          backgroundColor: secondary.main,
          '&:disabled': {
            backgroundColor: '#F0840F4D !important',
            color: '#5F6D83 !important',
          },
        },
        outlinedPrimary: {
          color: secondary.main,
          backgroundColor: primary.contrastText,
          border: `1px solid ${secondary.main}`,
          '&:hover': {
            border: `1px solid ${secondary.main}`,
          },
        },
        containedSecondary: {
          color: primary.textColor,
          border: '1px solid #23375952',
          backgroundColor: primary.contrastText,
          '&:hover': {
            border: `1px solid  ${primary.dark}`,
            backgroundColor: '#0000000D',
            color: secondary.main,
          },
          '&:disabled': {
            backgroundColor: '#0000001F !important',
            color: '#9E9E9EE5 !important',
          },
        },
        outlinedSecondary: {
          color: primary.textColor,
          border: '1px solid #23375952',
          backgroundColor: primary.contrastText,
          '&:hover': {
            border: '1px solid #23375952',
            backgroundColor: '#0000000D',
          },
          '&:disabled': {
            backgroundColor: '#0000001F !important',
            color: '#9E9E9EE5 !important',
          },
        },
        textSecondary: {
          color: primary.textColor,
          border: 'none',
          backgroundColor: primary.contrastText,
          '&:hover': {
            border: 'none',
            backgroundColor: '#0000000D',
            color: secondary.textColor,
          },
          '&:disabled': {
            backgroundColor: '#0000001F !important',
            color: '#9E9E9EE5 !important',
          },
        },
        textPrimary: {
          color: secondary.main,
          border: 'none',
          backgroundColor: primary.contrastText,
          '&:hover': {
            border: 'none',
            backgroundColor: '#0000000D',
            color: secondary.main,
          },
          '&:disabled': {
            backgroundColor: '#0000001F !important',
            color: '#9E9E9EE5 !important',
          },
        },
        containedError: {
          '&:disabled': {
            backgroundColor: '#f4433640 !important',
            color: '#5F6D83 !important',
          },
        },
      },
    },
  },
});

export default buttonTheme;
